var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Modal from "@hg/modal";
import { RealRewardStep } from "./types";
import { CouponStatus, TaskStatus } from "../../../types";
import { getRequestClient } from "../../../utils/request";
import { DefaultFailedContent, DefaultPreLotteryContent, DefaultRealRewardContent, DefaultVirtualRewardContent } from "./default";
import { fetchDraws, syncTask } from "../../../services/infos";
import { doDraw, saveContact } from "../../../services/actions";
export var createLotterySDK = function (config) {
    var baseURL = config.baseURL, sdkReady = config.sdkReady, activityCid = config.activityCid, couponCid = config.couponCid, taskCid = config.taskCid, errCode2Msg = config.errCode2Msg;
    getRequestClient({ baseURL: baseURL, sdkReady: sdkReady, errCode2Msg: errCode2Msg });
    var lotteryState = {
        status: CouponStatus.DEFAULT,
        reward: null,
        contact: null,
        loading: false,
        error: null,
        coupon: null,
    };
    var roleMeta = null;
    var setRoleMeta = function (meta) {
        roleMeta = meta;
    };
    var lotterySubscribers = [];
    var updateLotteryState = function (partial) {
        lotteryState = __assign(__assign({}, lotteryState), partial);
        lotterySubscribers.forEach(function (cb) { return cb(lotteryState); });
    };
    var collect = function (event_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([event_1], __read(args_1), false), void 0, function (event, properties) {
            var sdk;
            if (properties === void 0) { properties = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sdkReady()];
                    case 1:
                        sdk = _a.sent();
                        sdk.ETL.event(event, properties);
                        return [2 /*return*/];
                }
            });
        });
    };
    var defaultServices = {
        getDraws: function () {
            return __awaiter(this, void 0, void 0, function () {
                var res, err;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchDraws(activityCid)];
                        case 1:
                            res = _a.sent();
                            if (res.code === 0) {
                                return [2 /*return*/, res.data];
                            }
                            else {
                                err = new Error(res.msg);
                                err.code = res.code;
                                err.msg = res.msg;
                                throw err;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        syncTask: function () {
            return __awaiter(this, void 0, void 0, function () {
                var res, err;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, syncTask(activityCid)];
                        case 1:
                            res = _a.sent();
                            if (res.code === 0) {
                                return [2 /*return*/, res.data];
                            }
                            else {
                                err = new Error(res.msg);
                                err.code = res.code;
                                err.msg = res.msg;
                                throw err;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        doDraw: function () {
            return __awaiter(this, void 0, void 0, function () {
                var res, err;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, doDraw({ activityCid: activityCid, couponCid: couponCid })];
                        case 1:
                            res = _a.sent();
                            if (res.code === 0) {
                                return [2 /*return*/, res.data];
                            }
                            else {
                                err = new Error(res.msg);
                                err.code = res.code;
                                err.msg = res.msg;
                                throw err;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        saveContact: function (contact) {
            return __awaiter(this, void 0, void 0, function () {
                var res, err;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, saveContact({ activityCid: activityCid, couponCid: couponCid, contactInfo: contact })];
                        case 1:
                            res = _a.sent();
                            if (res.code === 0) {
                                return [2 /*return*/, res.data];
                            }
                            else {
                                err = new Error(res.msg);
                                err.code = res.code;
                                err.msg = res.msg;
                                throw err;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    };
    // 获取抽奖状态
    var refreshLotteryStatus = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], __read(args_1), false), void 0, function (services) {
            var drawInfo, coupon, error_1;
            var _a, _b, _c, _d;
            if (services === void 0) { services = defaultServices; }
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (lotteryState.loading) {
                            return [2 /*return*/];
                        }
                        updateLotteryState({ loading: true, error: null });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, services.getDraws()];
                    case 2:
                        drawInfo = _e.sent();
                        coupon = (_a = drawInfo.coupons) === null || _a === void 0 ? void 0 : _a.find(function (q) { return q.cid === config.couponCid; });
                        updateLotteryState({
                            status: (coupon === null || coupon === void 0 ? void 0 : coupon.status) || CouponStatus.DEFAULT,
                            reward: (coupon === null || coupon === void 0 ? void 0 : coupon.result) ? __assign(__assign({}, config.rewardMap[(_c = (_b = coupon.result) === null || _b === void 0 ? void 0 : _b.prizeName) !== null && _c !== void 0 ? _c : coupon.result.giftName]), { prizeName: (_d = coupon.result) === null || _d === void 0 ? void 0 : _d.prizeName, giftName: coupon.result.giftName }) : null,
                            contact: drawInfo.contactInfo ? (drawInfo.contactInfo[config.couponCid] || null) : null,
                            coupon: coupon || null,
                            loading: false
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _e.sent();
                        updateLotteryState({ error: error_1, reward: null, status: CouponStatus.FAILED, contact: null });
                        return [3 /*break*/, 5];
                    case 4:
                        updateLotteryState({ loading: false });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // 执行抽奖
    var performDraw = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], __read(args_1), false), void 0, function (services, rewardMap) {
            var drawResult, rewardInfo, fullReward, error_2;
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (services === void 0) { services = defaultServices; }
            if (rewardMap === void 0) { rewardMap = config.rewardMap; }
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _j.trys.push([0, 2, , 3]);
                        (_b = (_a = config.callbacks) === null || _a === void 0 ? void 0 : _a.onDrawStart) === null || _b === void 0 ? void 0 : _b.call(_a);
                        return [4 /*yield*/, services.doDraw()];
                    case 1:
                        drawResult = _j.sent();
                        rewardInfo = drawResult ? rewardMap[(_c = drawResult === null || drawResult === void 0 ? void 0 : drawResult.prizeName) !== null && _c !== void 0 ? _c : drawResult.giftName] : null;
                        if (rewardInfo && drawResult) {
                            fullReward = __assign(__assign({}, rewardInfo), { 
                                // prizeName: drawResult?.prizeName,
                                giftName: drawResult.giftName });
                            (_e = (_d = config.callbacks) === null || _d === void 0 ? void 0 : _d.onDrawSuccess) === null || _e === void 0 ? void 0 : _e.call(_d, fullReward);
                            if ((_f = config.options) === null || _f === void 0 ? void 0 : _f.enableAnalytics) {
                                collect("lottery", {
                                    result: rewardInfo.type === "virtual" ? "virtual_items" : "material_items"
                                });
                            }
                            refreshLotteryStatus(services);
                            return [2 /*return*/, { success: true, reward: fullReward }];
                        }
                        return [2 /*return*/, { success: false, result: drawResult }];
                    case 2:
                        error_2 = _j.sent();
                        console.error("抽奖失败:", error_2);
                        (_h = (_g = config.callbacks) === null || _g === void 0 ? void 0 : _g.onDrawFailed) === null || _h === void 0 ? void 0 : _h.call(_g, error_2);
                        // config.callbacks?.onCommonError?.({
                        //     code: error.code,
                        //     msg: error.message
                        // })
                        return [2 /*return*/, { success: false, error: error_2 }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // 显示前置弹窗
    var preLottery = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], __read(args_1), false), void 0, function (services, rewardMap) {
            var result, PreLotteryContent;
            var _a, _b, _c;
            if (services === void 0) { services = defaultServices; }
            if (rewardMap === void 0) { rewardMap = config.rewardMap; }
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!!((_a = config.options) === null || _a === void 0 ? void 0 : _a.enablePreLottery)) return [3 /*break*/, 2];
                        return [4 /*yield*/, performDraw(services, rewardMap)];
                    case 1:
                        result = _d.sent();
                        if (result.success && result.reward) {
                            if (result.reward.type === "virtual") {
                                showVirtualRewardModal(result.reward);
                            }
                            else {
                                showRealRewardModal({
                                    useTempAddress: (roleMeta === null || roleMeta === void 0 ? void 0 : roleMeta.channel) !== "account",
                                    reward: result.reward,
                                    initialContact: lotteryState.contact,
                                    services: services
                                });
                            }
                        }
                        else {
                            if (result.error) {
                                (_b = config.callbacks) === null || _b === void 0 ? void 0 : _b.onCommonError(result.error);
                            }
                            else {
                                showFailedModal("noReward");
                            }
                        }
                        return [2 /*return*/];
                    case 2:
                        PreLotteryContent = ((_c = config.ui) === null || _c === void 0 ? void 0 : _c.preLotteryContent) || DefaultPreLotteryContent;
                        return [2 /*return*/, Modal.show(function (_a) {
                                var onClose = _a.onClose;
                                var _b = __read(React.useState(false), 2), loading = _b[0], setLoading = _b[1];
                                var handleConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
                                    var result;
                                    var _a;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                if (loading)
                                                    return [2 /*return*/];
                                                setLoading(true);
                                                return [4 /*yield*/, performDraw(services, rewardMap)];
                                            case 1:
                                                result = _b.sent();
                                                setLoading(false);
                                                if (result.success && result.reward) {
                                                    if (result.reward.type === "virtual") {
                                                        showVirtualRewardModal(result.reward);
                                                    }
                                                    else {
                                                        showRealRewardModal({
                                                            useTempAddress: (roleMeta === null || roleMeta === void 0 ? void 0 : roleMeta.channel) !== "account",
                                                            reward: result.reward,
                                                            initialContact: lotteryState.contact,
                                                            services: services
                                                        });
                                                    }
                                                    onClose();
                                                }
                                                else {
                                                    if (result.error) {
                                                        (_a = config.callbacks) === null || _a === void 0 ? void 0 : _a.onCommonError(result.error);
                                                    }
                                                    else {
                                                        showFailedModal("noReward");
                                                        onClose();
                                                    }
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                }); };
                                return (_jsx(PreLotteryContent, { onConfirm: handleConfirm, onClose: onClose, loading: loading }));
                            })];
                }
            });
        });
    };
    // 显示虚拟奖品弹窗
    var showVirtualRewardModal = function (reward) {
        var _a;
        var VirtualRewardContent = ((_a = config.ui) === null || _a === void 0 ? void 0 : _a.virtualRewardContent) || DefaultVirtualRewardContent;
        return Modal.show(function (_a) {
            var onClose = _a.onClose;
            return (_jsx(VirtualRewardContent, { reward: reward, onClose: onClose }));
        });
    };
    // 显示实物奖品弹窗
    var showRealRewardModal = function (_a) {
        var _b;
        var useTempAddress = _a.useTempAddress, reward = _a.reward, initialContact = _a.initialContact, _c = _a.services, services = _c === void 0 ? defaultServices : _c;
        var RealRewardContent = ((_b = config.ui) === null || _b === void 0 ? void 0 : _b.realRewardContent) || DefaultRealRewardContent;
        return Modal.show(function (_a) {
            var onClose = _a.onClose;
            var _b = __read(React.useState(initialContact || {
                name: "",
                phone: "",
                address: "",
                province: "",
                city: "",
                county: ""
            }), 2), contact = _b[0], setContact = _b[1];
            var _c = __read(React.useState(initialContact ? RealRewardStep.PREVIEW : RealRewardStep.EDIT), 2), step = _c[0], setStep = _c[1];
            var _d = __read(React.useState(false), 2), loading = _d[0], setLoading = _d[1];
            var handleSubmitContact = function () { return __awaiter(void 0, void 0, void 0, function () {
                var error_3;
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!contact.name || !contact.phone || !contact.address) {
                                // Toast.message("请填写完整的收货信息")
                                (_a = config.callbacks) === null || _a === void 0 ? void 0 : _a.onCommonError({ code: -1, msg: "please fill in all the information" });
                                return [2 /*return*/];
                            }
                            setLoading(true);
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, services.saveContact(contact)];
                        case 2:
                            _e.sent();
                            setStep(RealRewardStep.DONE);
                            (_c = (_b = config.callbacks) === null || _b === void 0 ? void 0 : _b.onContactSaved) === null || _c === void 0 ? void 0 : _c.call(_b);
                            refreshLotteryStatus(services);
                            return [3 /*break*/, 5];
                        case 3:
                            error_3 = _e.sent();
                            // Toast.message(error.message || "保存失败，请重试")
                            (_d = config.callbacks) === null || _d === void 0 ? void 0 : _d.onCommonError(error_3);
                            return [3 /*break*/, 5];
                        case 4:
                            setLoading(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); };
            return (_jsx(RealRewardContent, { reward: reward, contact: contact, step: step, loading: loading, onContactChange: setContact, onStepChange: setStep, onSubmitContact: handleSubmitContact, onClose: onClose, useTempAddress: useTempAddress }));
        });
    };
    // 显示失败弹窗
    var showFailedModal = function (type) {
        var _a;
        var FailedContent = ((_a = config.ui) === null || _a === void 0 ? void 0 : _a.failedContent) || DefaultFailedContent;
        return Modal.show(function (_a) {
            var onClose = _a.onClose;
            return (_jsx(FailedContent, { onClose: onClose, type: type || "default" }));
        });
    };
    // refreshLotteryStatus()
    return {
        // 主要API - 执行抽奖流程
        start: function () { return __awaiter(void 0, void 0, void 0, function () {
            var couponStatus, reward, contact;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: 
                    // alert("start")
                    return [4 /*yield*/, refreshLotteryStatus()];
                    case 1:
                        // alert("start")
                        _c.sent();
                        if (lotteryState.loading) {
                            (_a = config.callbacks) === null || _a === void 0 ? void 0 : _a.onCommonError({ code: 1000, msg: "抽奖进行中，请稍候..." });
                            return [2 /*return*/];
                        }
                        // 没有coupon或者更新状态失败
                        if (lotteryState.error || lotteryState.coupon === null || lotteryState.status === null || lotteryState.status === undefined) {
                            showFailedModal();
                            return [2 /*return*/];
                        }
                        couponStatus = lotteryState.status, reward = lotteryState.reward, contact = lotteryState.contact;
                        switch (couponStatus) {
                            case CouponStatus.DRAWING:
                                // Toast.message("抽奖进行中，请稍候...")
                                (_b = config.callbacks) === null || _b === void 0 ? void 0 : _b.onCommonError({ code: 1000, msg: "抽奖进行中，请稍候..." });
                                break;
                            case CouponStatus.DEFAULT:
                                preLottery();
                                break;
                            case CouponStatus.USED:
                                if (reward) {
                                    if (reward.type === "virtual") {
                                        showVirtualRewardModal(reward);
                                    }
                                    else {
                                        showRealRewardModal({ useTempAddress: (roleMeta === null || roleMeta === void 0 ? void 0 : roleMeta.channel) !== "account", reward: reward, initialContact: contact });
                                    }
                                }
                                else {
                                    showFailedModal();
                                }
                                break;
                            default:
                                showFailedModal();
                                break;
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        lotteryOnly: function () { return __awaiter(void 0, void 0, void 0, function () {
            var couponStatus, reward, contact;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, refreshLotteryStatus()];
                    case 1:
                        _b.sent();
                        if (lotteryState.loading) {
                            (_a = config.callbacks) === null || _a === void 0 ? void 0 : _a.onCommonError({ code: 1000, msg: "抽奖进行中，请稍候..." });
                            return [2 /*return*/];
                        }
                        // 没有coupon或者更新状态失败
                        if (lotteryState.error || lotteryState.coupon === null || lotteryState.status === null || lotteryState.status === undefined) {
                            showFailedModal();
                            return [2 /*return*/];
                        }
                        couponStatus = lotteryState.status, reward = lotteryState.reward, contact = lotteryState.contact;
                        if (couponStatus === CouponStatus.DEFAULT) {
                            preLottery();
                            return [2 /*return*/];
                        }
                        else if (couponStatus === CouponStatus.USED) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        // 手动显示各种弹窗
        preLottery: preLottery,
        showVirtualReward: showVirtualRewardModal,
        showRealReward: showRealRewardModal,
        showFailed: showFailedModal,
        // 直接执行抽奖（返回结果，不显示弹窗）
        draw: performDraw,
        refreshLotteryStatus: refreshLotteryStatus,
        setRoleMeta: setRoleMeta,
        get lotteryState() { return lotteryState; },
        debugStart: function (type) {
            var testImgUrl = getTestImgUrl();
            var debugRewardMap = {
                "real_A": {
                    type: "real",
                    key: "real_A",
                    title: "reward.text_debug_real_A",
                    src: testImgUrl
                },
                "virtual_A": {
                    type: "virtual",
                    key: "virtual_A",
                    title: "reward.text_debug_virtual_A",
                    src: testImgUrl
                },
            };
            var debugReward = debugRewardMap[type === "real" ? "real_A" : "virtual_A"];
            var debugServices = {
                getDraws: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {
                                    coupons: [
                                        {
                                            cid: "12345",
                                            name: "test_coupon",
                                            rarity: 0,
                                            status: CouponStatus.USED,
                                            result: debugReward ? {
                                                prizeName: debugReward.key,
                                                // prizeId: "123",
                                                // prizeType: "GIFT"
                                                giftName: debugReward.key,
                                            } : null
                                        }
                                    ],
                                    contactInfo: null,
                                    address: null
                                }];
                        });
                    });
                },
                syncTask: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, [{
                                        cid: "123",
                                        status: TaskStatus.COMPLETED,
                                    }]];
                        });
                    });
                },
                doDraw: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {
                                    prizeName: debugReward.key,
                                    giftName: debugReward.key,
                                    // prizeId: "123",
                                    // prizeType: "GIFT"
                                }];
                        });
                    });
                },
                saveContact: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {}];
                        });
                    });
                }
            };
            preLottery(debugServices, type === "failed" ? {} : debugRewardMap);
        }
    };
};
var getTestImgUrl = function () {
    var canvas = document.createElement("canvas");
    canvas.width = 300;
    canvas.height = 200;
    var ctx = canvas.getContext("2d");
    if (!ctx)
        return "";
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, 300, 200);
    ctx.fillStyle = "#ccc";
    ctx.textBaseline = "middle";
    ctx.font = "bold 80px Arial";
    ctx.fillText("DEBUG", 0, 100);
    var src = canvas.toDataURL();
    canvas.remove();
    return src;
};
